var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z","fill":"#e04f00"})));
}

ArrowRight.defaultProps = {"version":"1.1","viewBox":"0 0 129 129","enableBackground":"new 0 0 129 129","width":"512px","height":"512px"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
